<template>
  <div class="text-center">
    <v-dialog
      v-model="loadingDialog"
      persistent
      width="350"
    >
      <v-card class="pa-8">
        <v-card-text class="pa-0 text-dialog">
          ระบบกำลังอัปเดตข้อมูลธุรกิจ กรุณารอสักครู่...
          <v-progress-linear
            indeterminate
            color="default_primary"
            class="mb-0 mt-5"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'LoadingDialogComponent',
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({
      loadingDialog: 'loadingDialog'
    })
  }
}
</script>
<style scoped>
.text-dialog {
  font-family: Noto Sans Thai !important;
  font-weight: 700;
  color: var(--v-header_text-base);
}
</style>
